import { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";

const LazyRouteWrapper = ({ children }) => (
    <Suspense fallback={
        <Box sx={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "50vh" }}>
            <CircularProgress color="primary" size={40} />
        </Box>
    }>
        {children}
    </Suspense>
);

export default LazyRouteWrapper;
